import { defineMessages } from 'react-intl';

export const messages: {
	betweenDateTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exactDateTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	maximumDateTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minimumDateTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requiredDateTime: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	betweenDateTime: {
		id: 'proforma-form-renderer.common.utils.validators.date-time.between-date-time',
		defaultMessage:
			'The date and time must be between the {minimumDate, date, medium} at {minimumTime, time, short} and the {maximumDate, date, medium} at {maximumTime, time, short}.',
		description: 'Validation message for field with date and time between a range.',
	},
	exactDateTime: {
		id: 'proforma-form-renderer.common.utils.validators.date-time.exact-date-time',
		defaultMessage:
			'The date and time must be exactly the {date, date, medium} at {time, time, short}.',
		description: 'Validation message for field with exact date and time.',
	},
	maximumDateTime: {
		id: 'proforma-form-renderer.common.utils.validators.date-time.maximum-date-time',
		defaultMessage:
			'The date and time must be on or before the {maximumDate, date, medium} at {maximumTime, time, short}.',
		description: 'Validation message for field with maximum date and time.',
	},
	minimumDateTime: {
		id: 'proforma-form-renderer.common.utils.validators.date-time.minimum-date-time',
		defaultMessage:
			'The date and time must be at or after the {minimumDate, date, medium} at {minimumTime, time, short}.',
		description: 'Validation message for field with minimum date and time.',
	},
	requiredDateTime: {
		id: 'proforma-form-renderer.common.utils.validators.date-time.required-date-time',
		defaultMessage: '{fieldLabel} is required. Please specify a date and time.',
		description: 'Validation message for required date time field with given label.',
	},
});
